import React from 'react'
import FaqHead from '../../HomePage/Faq/FaqHead'
import PccFaqMain from './PccFaqMain'

const PccFaq = () => {
  return (
   <div className="faqContainer">
      <div className="faqContent">
        <FaqHead heading="PCC Verification Service in Bangalore" />
        <PccFaqMain />
      </div>
    </div>
  )
}

export default PccFaq
